import { getCheapestRate } from '@shared/helpers';

export default function sortSearch(hotels, findOrder, providers_priority) {
  const indexedHotels = hotels.map((hotel, index) => ({ hotel, index }));

  const sorted = indexedHotels.sort((aObj, bObj) => {
    const a = aObj.hotel;
    const b = bObj.hotel;

    const rates_a = getCheapestRate(a?.rates) ?? a;
    const rates_b = getCheapestRate(b?.rates) ?? b;

    const provider_priority_a = providers_priority?.[a?.id_provider] ?? 0;
    const provider_priority_b = providers_priority?.[b?.id_provider] ?? 0;

    const availability_a = rates_a?.rooms?.[0]?.availability;
    const availability_b = rates_b?.rooms?.[0]?.availability;

    if (availability_a === 'ORQ' && availability_b !== 'ORQ') {
      return 1;
    }

    if (availability_b === 'ORQ' && availability_a !== 'ORQ') {
      return -1;
    }

    const order = findOrder(
      a,
      b,
      rates_a,
      rates_b,
      provider_priority_a,
      provider_priority_b
    );

    return order === 0 ? aObj.index - bObj.index : order;
  });

  return sorted.map(obj => obj.hotel);
}
